// import Vue from 'vue'
// import Router from 'vue-router'
// // import home from '@/views/home.vue'
const index = () => import('@/views/index/index.vue')

// const order = () => import('@/views/order.vue')

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 模拟用户登录状态
// const isAuthenticated = false

const routes = [{
		path: '/',
		component: index,
		children: [
			{
				path: '/',
				name: 'welfares',
				component: () => import('@/views/welfares/index.vue'),
				meta: {
					title: '商会服务',
					icon: 'el-icon-s-ticket'
				},
			},
			{
				path: '/member',
				name: 'member',
				component: () => import('@/views/member/index.vue'),
				meta: {
					title: '成员管理',
					icon: 'el-icon-s-custom'
				},
			}
		],
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/login/index.vue'),
		meta: {
			title: '登录',
			icon: 'el-icon-document'
		},
	},
	// {
	// 	path: '/register',
	// 	name: 'register',
	// 	component: () => import('@/views/register/index.vue'),
	// 	meta: { title: '注册', icon: 'el-icon-document' },
	// },
	{
		path: '/resetpwd',
		name: 'resetpwd',
		component: () => import('@/views/resetpwd/index.vue'),
		meta: {
			title: '忘记密码',
			icon: 'el-icon-document'
		},
	},
	{
		path: '/fuwuxieyi',
		name: 'fuwuxieyi',
		component: () => import('@/views/fuwixieyi/index.vue'),
		meta: {
			title: '服务协议',
			icon: 'el-icon-document'
		},
	},
]

const router = new VueRouter({
	mode: 'hash',

	routes,
})
router.beforeEach((to, from, next) => {
	// if(localStorage.getItem('token')){
	//   next()
	// }
	// else{
	// 				next({
	// 					path: '/login',
	// 				})
	// }
	// if (to.meta.title) {
	// 	document.title = to.meta.title
	// } else {
	// 	document.title = '全联商会平台'
	// }
	// console.log(localStorage.getItem('token'),'localStorage.getItem')

	// if (to.name === 'register' || to.name === 'resetpwd') {
	// 	console.log(from.name)
	// 	if (!from.name) {
	// 		if (localStorage.getItem('token')) {
	// 			next({
	// 				path: '/',
	// 			})
	// 		} else {
	// 			next({
	// 				name: 'login',
	// 			})
	// 		}
	// 	}
	// }

	// if (to.meta.requiresAuth && !localStorage.getItem('token')) {
	// 	// 避免重复跳转到登录页
	// 	if (to.name !== 'login') {
	// 		next({
	// 			name: 'login',
	// 		})
	// 	} else {
	// 		next()
	// 	}
	// } else if (to.name === 'login' && localStorage.getItem('token')) {
	// 	return next({ name: 'homePage' })
	// } else {
	// 	// 无需认证或已认证，继续导航
	// 	next()
	// }
	if (localStorage.getItem('token')) {
		next()
		if (to.meta.title) {
			document.title = to.meta.title
		} else {
			document.title = '全联商旅平台'
		}
	} else {
		if (to.path == '/login' || to.path == '/register' || to.path == '/resetpwd' || to.path ==
			'/fuwuxieyi') {
			next()
			if (to.meta.title) {
				document.title = to.meta.title
			} else {
				document.title = '全联商旅平台'
			}
		} else {
			next({
				path: '/login'
			})
			if (to.meta.title) {
				document.title = to.meta.title
			} else {
				document.title = '全联商旅平台'
			}
		}
	}
})
// })

export default router